module.exports = __webpack_public_path__ + "static/media/logo-royal-curator-white.dc7e62cb.png";